import { render } from "./CategoryNav.vue?vue&type=template&id=23e3582c&scoped=true"
import script from "./CategoryNav.vue?vue&type=script&lang=js"
export * from "./CategoryNav.vue?vue&type=script&lang=js"

import "./CategoryNav.vue?vue&type=style&index=0&id=23e3582c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e3582c"]])

export default __exports__